import { Component, OnInit, Input, TemplateRef, OnDestroy } from '@angular/core';
import { RelatedService } from '../services/related.service';
import { RelatedDocument, SimpleDocument, DocumentList, RelatedLevel } from '../objects/RelatedObject';

import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { Globals } from '../objects/Globals';
import { WorkspaceService } from '../services/workspace.service';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';

@Component({
  selector: 'app-related',
  templateUrl: './related.component.html',
  styleUrls: ['./related.component.css']
})
export class RelatedComponent implements OnInit {
  @Input() parentComponentId:string;
  @Input() baseDocumentId:string;
  @Input() baseDocumentType:string;
  @Input() documentTypeCode: string;
  @Input() relationType:string;
  @Input() set setDocumentList(doc:string){
    this.buildDocumentList(doc);
  }

  private componentId:string;
  private relatedDocumentObject:RelatedDocument;
  private selectedDoc:string;
  private levels: RelatedLevel[];
  private documentList: Document[];
  modalRef: BsModalRef;
  
  getRelatedDocument(relationName:string, template: TemplateRef<any>):void{
    this.relatedService.getRelatedDocuments(this.parentComponentId, relationName).subscribe(result => { 
       this.componentId = result;
       this.relatedService.getRelationCard(this.componentId).subscribe(data=> {
        const config: ModalOptions = {
          keyboard: false,
          ignoreBackdropClick: true,
          class: 'modal-dialog-centered modal-related'
        };
        this.modalRef = this.modalService.show(template, config);
          this.relatedDocumentObject = JSON.parse(data);
          this.levels = this.getLevels();
          
          this.getLevels().forEach(element=> {
            this.relatedService.getCardListDetail(this.componentId, element.DocumentType).subscribe(detailResult=>{
              if(detailResult == "1"){
                this.refreshRelatedCard();
              }
            });
          });
       });
    });
  }

  refreshRelatedCard(){
      this.relatedService.getRelationCard(this.componentId).subscribe(data=> {
         this.relatedDocumentObject = JSON.parse(data);
      });
  }

  onDecline(): void {
    this.modalRef.hide();
    document.body.classList.remove('modal-open');
  }

  getLevels():RelatedLevel[]{
    return this.relatedDocumentObject.LevelMapping.filter(x=> x.DisplaySummaryType != "").sort((a:RelatedLevel,b:RelatedLevel) => { 
      if(a.Sequence > b.Sequence){
        return 1;
      }else if(a.Sequence < b.Sequence){
        return -1;
      }else{
        return 0;
      }
     });
  }

  getLevelDocument(docType:string):SimpleDocument[]{
    if(this.relatedDocumentObject.Levels[docType].length > 0){
      return this.relatedDocumentObject.Levels[docType];
    }
  }

  highlightDirectRelated(docType:string, docId:string):void{
    this.clearAllHighlights();
    this.relatedService.selectHighlightCard(this.componentId, docType, docId).subscribe(result=> {
      var highlightDoc:DocumentList = JSON.parse(result);
      this.getLevels().forEach(element => {
        highlightDoc[element.DocumentType].forEach(item=>{
          this.selectedDoc = docId;
          this.relatedDocumentObject.Levels[element.DocumentType].find(doc=> doc.DocumentId == item).Highlight = true;
        });
      });
    });
  }

  showRelatedDocument(docType:string, docId:string){
    this.relatedService.selectCard(this.componentId, docType, docId).subscribe(result=>{
      // this.modalRef.hide();
      // this.router.navigate(["detail", result]);
      if (result){
        this.openDetailPopup(result, "");
      }
      
    });
  }

  openDetailPopup(event, title: string) {
    const config: ModalOptions = {
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered modal-detail',
      initialState: {
        componentId: event,
        title: title
      }
    };
    

    if (this.modalService.getModalsCount() > 0){
      document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
    }

    this.modalService.onHide.subscribe((reason: string) => {
      if (this.modalService.getModalsCount() > 0){
        document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.add('show');
      }
    })

    this.modalService.show(DetailPopupComponent, config);
  }

  clearAllHighlights():void{
    this.getLevels().forEach(element => {
      this.relatedDocumentObject.Levels[element.DocumentType].forEach(subElement=> {
        subElement.Highlight = false;
      });
    });
  }

  constructor(private relatedService:RelatedService,
    private modalService: BsModalService, private router:Router, private globals: Globals, private workspaceService: WorkspaceService) { }

  ngOnInit() {}

  buildDocumentList(dirtyList: string){
    // dirtyList = "(Bank:Compare)|(Doc:Additional Info)|LO:Accept Offer|";
    
    this.documentList = [];
    var index = 0;
    dirtyList.split('|').forEach(document => {
      if (document.replace('(', '').replace(')', '') == ""){
        this.documentList[index - 1].IsFullSelected = true;
      }else{
        var doc: Document = new Document();
        doc.ImageName = document.split(':')[0].replace('(', '').replace(')', '');
        doc.Title = document.split(':')[1] ? document.split(':')[1].replace('(', '').replace(')', '') : "";
        doc.IsSelected = document.indexOf('(') > -1;
        
        if (doc.IsSelected && this.documentList[index - 1]){
          this.documentList[index - 1].IsFullSelected = true;
        }

        this.documentList.push(doc);
      }
      
      index++;
    });
    // console.log(this.documentList);
  }
}

export class Document {
  ImageName: string;
  Title: string;
  IsSelected: boolean;
  IsFullSelected: boolean;
}